// The function toggles more (hidden) text when the user clicks on "Read more". The IF ELSE statement ensures that the text 'read more' and 'read less' changes interchangeably when clicked on.
$('.moreless-button').click(function() {
  $('.moretext').slideToggle("fast");
  if ($('.moreless-button').text() == "More") {
    $(this).text("Less")
  } else {
    $(this).text("More")
  }

  return false;
});